import { Component, OnInit, OnDestroy } from '@angular/core';

import { AlertService, Alert, AlertType } from '../alert.service';

@Component({
    moduleId: module.id,
    selector: 'alert',
    templateUrl: 'alert.component.html',
    styleUrls: ['alert.component.scss']
})

export class AlertComponent implements OnDestroy {

    alerts: Alert[] = [];
    intervalId: number;

    constructor(private alertService: AlertService) { }

    ngOnDestroy(): void {
        clearInterval(this.intervalId);
    }

    ngOnInit() {
        this.alertService.getAlert().subscribe((alert: Alert) => {
            if (!alert) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            // add alert to array
            this.alerts.push(alert);
        });
        let that = this;
        this.intervalId = window.setInterval(() => { this.interval(that); }, 1000);
    }

    interval(that: AlertComponent) {
        that.alerts.forEach(alert => {
            if (alert.seconds > 0) {
                alert.seconds--;
                if (alert.seconds == 0) {
                    that.removeAlert(alert);
                }
            }
        });
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success';
            case AlertType.Error:
                return 'alert alert-danger';
            case AlertType.Info:
                return 'alert alert-info';
            case AlertType.Warning:
                return 'alert alert-warning';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/alert/alert.component.ts